import { cookieStorage } from "@/pinia/cookieStorage";

const clearCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

let publicReloadPending = false;

/**
 * Mirror the auth-expiry behaviour of the axios response interceptor for
 * callers that go around axios (e.g. fetch-based streaming). When the
 * server reports an invalid/expired token, drop the session and bounce
 * the user to /login so they don't get stuck staring at a silent error.
 * Public pages reload once without the session instead, so they still open.
 */
export function redirectOnExpiredAuth() {
    if (publicReloadPending) {
        return;
    }

    const auth = JSON.parse(cookieStorage.getItem("auth") || "{}");

    if (auth.isImpersonating) {
        auth.isImpersonating = false;
        auth.impersonationExpiresAt = null;
        auth.token = null;
        cookieStorage.setItem("auth", JSON.stringify(auth));
        window.location.pathname = "/login";
        return;
    }

    cookieStorage.removeItem("auth");
    cookieStorage.removeItem("user-uid");
    clearCookie("auth");
    clearCookie("user-uid");

    if (isPublicPath(window.location.pathname) && claimPublicReload()) {
        publicReloadPending = true;
        window.location.reload();
        return;
    }

    window.location.pathname = "/login";
}

const PUBLIC_PATH_PREFIXES = ["/unsubscribe/", "/public-news"];
const PUBLIC_RELOAD_KEY = "auth-expired-public-reload-at";
const PUBLIC_RELOAD_WINDOW_MS = 10000;

const isPublicPath = (pathname) => PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));

function claimPublicReload() {
    try {
        const lastReloadAt = Number(window.sessionStorage.getItem(PUBLIC_RELOAD_KEY));

        if (Date.now() - lastReloadAt < PUBLIC_RELOAD_WINDOW_MS) {
            return false;
        }

        window.sessionStorage.setItem(PUBLIC_RELOAD_KEY, String(Date.now()));

        return true;
    } catch {
        return false;
    }
}
